export const ACCESS_REASONS = [
    'no_account',
    'domain_not_allowed',
    'inactive',
    'provider_error'
];
export const ACCESS_PROVIDERS = [
    'microsoft',
    'google',
    'saml'
];
export const MAX_EMAIL_LENGTH = 254;
export const MAX_ORG_LENGTH = 120;
const EMAIL_SHAPE = /^[^\s@<>"]+@[^\s@<>"]+\.[^\s@<>"]+$/;
function cap(value, max) {
    return value.length <= max ? value : value.slice(0, max);
}
export function parseAccessReason(raw) {
    if (raw && ACCESS_REASONS.includes(raw)) {
        return raw;
    }
    return 'unknown';
}
export function parseAccessEmail(raw) {
    if (!raw) return '';
    const trimmed = cap(raw.trim(), MAX_EMAIL_LENGTH);
    if (!EMAIL_SHAPE.test(trimmed)) return '';
    return trimmed;
}
export function parseAccessOrg(raw) {
    if (!raw) return '';
    return cap(raw.trim().replace(/[\r\n\0]/g, ' '), MAX_ORG_LENGTH);
}
export function parseAccessProvider(raw) {
    if (raw && ACCESS_PROVIDERS.includes(raw)) {
        return raw;
    }
    return '';
}
export function emailDomain(email) {
    const at = email.lastIndexOf('@');
    if (at <= 0 || at === email.length - 1) return '';
    return email.slice(at + 1);
}
export function adminInviteMessage(email, org) {
    const who = email || 'this person';
    const where = org || 'this organization';
    return `Hi — please invite ${who} to ${where} in Specra.`;
}
export function orgLabel(org) {
    return org || 'this organization';
}
